import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from '@tanstack/react-router';
import PasswordResetScreen from 'components/PasswordResetScreen';
import { useConfirmPasswordReset } from 'features/auth';
export default function ResetPasswordScreen({ code }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [formMessage, setFormMessage] = useState('');
    const [globalMessage, setGlobalMessage] = useState('');
    const confirm = useConfirmPasswordReset();
    const handleSubmit = async () => {
        const trimmed = password.trim();
        if (trimmed.length < 6) {
            setFormMessage(t('auth_password_too_short'));
            return;
        }
        setFormMessage('');
        try {
            await confirm.mutateAsync({ code, newPassword: trimmed });
            setGlobalMessage(t('reset_password_updated'));
            setPassword('');
            navigate({ to: '/login' });
        }
        catch {
            setFormMessage(t('reset_link_invalid'));
        }
    };
    return (_jsx(PasswordResetScreen, { formMessage: formMessage, globalMessage: globalMessage, isSubmitting: confirm.isPending, onBackToLogin: () => navigate({ to: '/login' }), onPasswordChange: (value) => {
            setPassword(value);
            if (formMessage)
                setFormMessage('');
        }, onSubmit: handleSubmit, password: password }));
}
